import { cn } from "@/lib/utils";

export function Diamond({ tone = 'accent', className }: {
    tone?: 'accent' | 'dim';
    className?: string;
}) {
    return <span className={cn('diamond', tone === 'dim' && 'diamond--dim', className)} />;
}


export function Hairline({ direction = 'right', className }: {
    direction?: 'right' | 'left';
    className?: string;
}) {
    return (
        <span className={cn(
            'h-px flex-1 shrink',
            direction === 'right' ? 'hairline-right' : 'hairline-left',
            className,
        )} />
    );
}


export function Ornament({ anchor = 'left', className }: {
    anchor?: 'left' | 'right';
    className?: string;
}) {
    return (
        <span className={cn('flex items-center gap-1.5', className)}>
            {anchor === 'left' ? <Diamond /> : <Hairline direction="left" />}
            {anchor === 'left' ? <Hairline direction="right" /> : <Diamond />}
        </span>
    );
}


export function DiamondDivider({ className }: { className?: string }) {
    return (
        <span className={cn('flex items-center gap-1.5', className)}>
            <Hairline direction="left" />
            <Diamond />
            <Hairline direction="right" />
        </span>
    );
}


export function Eyebrow({ children, className }: {
    children: React.ReactNode;
    className?: string;
}) {
    return (
        <span className={cn('flex items-center gap-1.5 min-w-0', className)}>
            <Diamond />
            <span className="truncate-flex font-rad text-label uppercase tracking-[.12em] text-faint scrim">
                {children}
            </span>
        </span>
    );
}
